import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./tipiCombustibileStore"
import Actions from "./tipiCombustibileActions"

export let withTipiCombustibile = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());